import React from "react";
import { Typography, FormLabel, Box } from "@material-ui/core";
import {
  RadioSelector,
  SelectorProps,
  DropdownSelector,
} from "../../../components/Forms";

export const MultiContactSelector: React.FC<SelectorProps> = ({
  options,
  onChange,
}) => {
  const label = (
    <Box clone mb={1}>
      <Typography variant="body1" color="textPrimary">
        Who is contacting you?
      </Typography>
    </Box>
  );
  return (
    <>
      <FormLabel>{label}</FormLabel>
      {options.length === 2 ? (
        <RadioSelector name="contact" options={options} onChange={onChange} />
      ) : (
        <DropdownSelector
          name="contact"
          options={options}
          onChange={onChange}
          fieldProps={{
            required: true,
          }}
        />
      )}
    </>
  );
};
